const search = {
  name: 'name',
  identification: 'identification',
  // logs
  所属机构: 'Orgnaiztion',
  日志类型: 'Log Type',
  登录方式: 'Login Type',
  模糊查询: 'Fuzzy Search',
  发生时间: 'Occurred Time',
  // alarm
  序列号: 'SN',
  实体: 'Entity',
  告警状态: 'Alarm Statu',
  告警时间: 'Alarm Time',
  // device
  设备类型: 'Device Model',
  生产日期: 'Create Time',
  选择日期: 'select date',
  大于: 'greater than',
  小于: 'less than',
  之间: 'between',
  之前: 'before',
  之后: 'after',
  选择时间: 'select time',
  // supervise
  分组: 'Group',
  姓名: 'Name',
  身份证号: 'Person ID',
  身份证: 'Person ID',
  性别: 'Gender',
  住址: 'Address',
  工作单位: 'Company',
  信用评价: 'Credit',
  备注: 'Remark',
  // deviceComp
  selectDeviceModel: 'please select device model',
  // placeholder
  '设备号/序列号': 'Extra/SN',
  请选择分组: 'please select group',
  请输入序列号SN: 'please input device SN',
  请输入实体姓名: 'please input entity name',
  请选择告警状态: 'please select alarm statu',
  请选择日志类型: 'please select log type',
  请选择登录方式: 'please select login type',
  请输入要查询的内容: 'please input what you want',
}
export default search